import { FC } from 'react';

import { StepCard, StepCardProps } from './StepCard';

import { ScStepsSection } from './styled';

interface StepSectionProps {
  title: string;
  steps: StepCardProps[];
}

export const StepsSection: FC<StepSectionProps> = ({ title, steps }) => {
  return (
    <ScStepsSection>
      <div className="title">{title}</div>
      <div className="steps">
        {steps.map((step) => (
          <StepCard {...step} key={step.title} />
        ))}
      </div>
    </ScStepsSection>
  );
};
